import ProjectsHeroSection from "../companents/Projects/PeojectsHeroSection/Index";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import Loading from "../companents/shared/Loading/Loading";

const Project = () => {
  const [isLoading, setIsLoading] = useState(true);



  return (
    <>
      <Helmet>
        <title>Layihələrimiz</title>
      </Helmet>

    
        
          <ProjectsHeroSection />
       
    
    </>
  );
};

export default Project;
